/* tslint:disable */
/* eslint-disable */
/**
 * ClimatePartner API Order Service
 * A Unified API for all ClimatePartner products
 *
 * The version of the OpenAPI document: 1.3.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * Latest status of the order in journal (e.g. ORDER_PENDING)
 */

export enum OrderStatusEnum {
    CreatePending = 'CREATE_PENDING',
    CreateProcessing = 'CREATE_PROCESSING',
    CreateFailed = 'CREATE_FAILED',
    CreateSuccessful = 'CREATE_SUCCESSFUL',
    DeletePending = 'DELETE_PENDING',
    DeleteProcessing = 'DELETE_PROCESSING',
    DeleteFailed = 'DELETE_FAILED',
    DeleteSuccessful = 'DELETE_SUCCESSFUL',
    UpdateSuccessful = 'UPDATE_SUCCESSFUL',
    UpdateProcessing = 'UPDATE_PROCESSING',
    UpdateFailed = 'UPDATE_FAILED',
    UpdatePending = 'UPDATE_PENDING',
    MigrationSuccessful = 'MIGRATION_SUCCESSFUL',
    MigrationFailed = 'MIGRATION_FAILED'
}



